import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { ClearButton } from '#/shared/components/Styled';
import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import GTM_HANDLES from '#/shared/gtm-handles';

const STOP_ROW_MIN_HEIGHT = '50px';

export const StopRow = styled.div`
  display: flex;
  min-height: ${STOP_ROW_MIN_HEIGHT};
  user-select: none;
  background-color: ${props => props.theme.secondaryBackgroundColor};
  border: 1px solid ${props => props.theme.tertiaryColor};
  border-radius: 5px;
  margin: 2px 0;
  transition: ${props => props.theme.boxShadowTransition};
  @media (any-hover: hover) {
    &:hover {
      transition: ${props => props.theme.boxShadowTransition};
      box-shadow: ${props => props.theme.boxShadowCardHover};
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.secondaryBackgroundColor};
    outline: none;
  }

  /* Prevents focus indicator being cut off final stop buttons */
  &:last-child {
    margin-bottom: 4px;
  }
`;

export const RouteColumn = styled.div`
  flex: 0 1 30px;
  padding-left: 8px;
`;

export const ArrivalDescriptionColumn = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  margin: 0 5px;
`;

export const StopNavigationButton = injectIntl(styled(ClearButton).attrs(
  ({ intl, $collapsed }) => ({
    [GTM_DATA_ATTRIBUTE]: GTM_HANDLES.shared.stopNavigationButton,
    role: 'link',
    title: $collapsed
      ? intl.formatMessage({ id: 'nearbystops.stopbuttontooltip' })
      : undefined,
  })
)`
  background-color: transparent;
  border: 0;
  text-align: left;
  flex: 2 1 auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  font-size: 1em;
  user-select: none;
  &:hover {
    background-color: transparent;
  }
`);

export const VanityNameDiv = styled.div`
  font-weight: 600;
  color: ${props => props.theme.primaryFontColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-height: 1.2em;
  min-width: 0;
`;

export const StopName = styled.div`
  font-size: 0.9em;
  color: ${props => props.theme.secondaryFontColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const ArrivalTimeColumn = styled.div`
  color: ${props => props.theme.mainColor};
  padding: 5px 10px 5px 5px;
  background-color: transparent;
  flex: 0 0 80px;
  text-align: end;
`;

export const StopsAlternativeMessage = styled.div`
  flex: 0 1 auto;
  padding: 10px;
  margin: 0 0 8px 0;
  align-self: center;
  max-width: 500px;
`;
